import { z } from 'zod';

import { cuidLike } from '../zod-common';

export const RATING_DIRECTIONS = ['REQUESTER_TO_BIDDER', 'BIDDER_TO_REQUESTER'] as const;
export type RatingDirectionValue = (typeof RATING_DIRECTIONS)[number];

const score = z.number().int().min(1).max(5);
const optionalComment = z.string().trim().max(1000).optional();

export const requesterToBidderScoresSchema = z.object({
  quality: score,
  respectOfScope: score,
  respectOfDeadline: score,
  communication: score,
  wouldRecommend: z.boolean(),
});
export type RequesterToBidderScores = z.infer<typeof requesterToBidderScoresSchema>;

export const bidderToRequesterScoresSchema = z.object({
  clarityOfBrief: score,
  responsiveness: score,
  paymentCompliance: score,
  respectOfBidder: score,
  wouldWorkAgain: z.boolean(),
});
export type BidderToRequesterScores = z.infer<typeof bidderToRequesterScoresSchema>;

export const ratingSubmitSchema = z.object({
  projectId: cuidLike,
  scores: z.union([requesterToBidderScoresSchema, bidderToRequesterScoresSchema]),
  comment: optionalComment,
});
export type RatingSubmitInput = z.infer<typeof ratingSubmitSchema>;

export const ratingByProjectSchema = z.object({
  projectId: cuidLike,
});
export type RatingByProjectInput = z.infer<typeof ratingByProjectSchema>;

export const ratingSummaryForUserSchema = z.object({
  userId: cuidLike,
});
export type RatingSummaryForUserInput = z.infer<typeof ratingSummaryForUserSchema>;

export const ratingListForUserSchema = z.object({
  userId: cuidLike,
  cursor: z.string().optional(),
  limit: z.number().int().min(1).max(100).default(20),
});
export type RatingListForUserInput = z.infer<typeof ratingListForUserSchema>;
